import _regeneratorRuntime from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export var createAudioDestinationNodeRenderer = function createAudioDestinationNodeRenderer(renderInputsOfAudioNode) {
  var nativeAudioDestinationNodePromise = null;

  var createAudioDestinationNode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proxy, nativeOfflineAudioContext, trace) {
      var nativeAudioDestinationNode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
              _context.next = 3;
              return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode, trace);

            case 3:
              return _context.abrupt("return", nativeAudioDestinationNode);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createAudioDestinationNode(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    render: function render(proxy, nativeOfflineAudioContext, trace) {
      if (nativeAudioDestinationNodePromise === null) {
        nativeAudioDestinationNodePromise = createAudioDestinationNode(proxy, nativeOfflineAudioContext, trace);
      }

      return nativeAudioDestinationNodePromise;
    }
  };
};